// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: jinja.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { DarwinAgentType, darwinAgentTypeFromJSON, darwinAgentTypeToJSON } from "./common";
import { DarwinToolType, darwinToolTypeFromJSON, darwinToolTypeToJSON } from "./darwin_agent";

export const protobufPackage = "com.anko.darwin";

/** Jinja variable with metadata */
export interface JinjaVariable {
  /** Variable name */
  name?:
    | string
    | undefined;
  /** Variable description */
  description?:
    | string
    | undefined;
  /** Variable type */
  type?:
    | string
    | undefined;
  /** Usage example */
  example?: string | undefined;
}

/** Agent input variables */
export interface AgentInputVariables {
  /** agent type */
  agent_type?:
    | DarwinAgentType
    | undefined;
  /** Agent input variables (available based on agent type) */
  input_variables: JinjaVariable[];
}

/** Tool input variables */
export interface ToolInputVariables {
  /** Darwin tool type enum */
  tool_type?:
    | DarwinToolType
    | undefined;
  /** Tool template input variables */
  input_variables: JinjaVariable[];
}

/** Jinja function with metadata */
export interface JinjaFunction {
  /** Function name */
  name?:
    | string
    | undefined;
  /** Function description */
  description?:
    | string
    | undefined;
  /** Function parameters */
  parameters: string[];
  /** Return type */
  return_type?:
    | string
    | undefined;
  /** Usage example */
  example?: string | undefined;
}

/** Jinja object (MKG class) with its variables and functions */
export interface JinjaObject {
  /** Object name (e.g., "custom_agent") */
  name?:
    | string
    | undefined;
  /** Object type/class name (e.g., "CustomAgent") */
  type?:
    | string
    | undefined;
  /** Object description */
  description?:
    | string
    | undefined;
  /** Variables (properties) available on this object */
  object_variables: JinjaVariable[];
  /** Functions (methods) available on this object */
  object_functions: JinjaFunction[];
}

/** Complete Jinja environment metadata */
export interface JinjaEnv {
  /** MKG objects with their variables and functions */
  objects: JinjaObject[];
  /** Utility functions (not tied to any object) */
  utility_functions: JinjaFunction[];
  /** Agent input variables (available based on agent type) */
  agent_input_variables: AgentInputVariables[];
  /** Global Override Jinja Variables */
  env_variables: JinjaVariable[];
  /** Tool input variables */
  tool_input_variables: ToolInputVariables[];
  /** Skill prompt input variables */
  skill_input_variables: JinjaVariable[];
}

function createBaseJinjaVariable(): JinjaVariable {
  return { name: undefined, description: undefined, type: undefined, example: undefined };
}

export const JinjaVariable: MessageFns<JinjaVariable> = {
  encode(message: JinjaVariable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    if (message.type !== undefined) {
      writer.uint32(26).string(message.type);
    }
    if (message.example !== undefined) {
      writer.uint32(34).string(message.example);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JinjaVariable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJinjaVariable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.example = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JinjaVariable {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      type: isSet(object.type) ? globalThis.String(object.type) : undefined,
      example: isSet(object.example) ? globalThis.String(object.example) : undefined,
    };
  },

  toJSON(message: JinjaVariable): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.type !== undefined) {
      obj.type = message.type;
    }
    if (message.example !== undefined) {
      obj.example = message.example;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JinjaVariable>, I>>(base?: I): JinjaVariable {
    return JinjaVariable.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JinjaVariable>, I>>(object: I): JinjaVariable {
    const message = createBaseJinjaVariable();
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.type = object.type ?? undefined;
    message.example = object.example ?? undefined;
    return message;
  },
};

function createBaseAgentInputVariables(): AgentInputVariables {
  return { agent_type: undefined, input_variables: [] };
}

export const AgentInputVariables: MessageFns<AgentInputVariables> = {
  encode(message: AgentInputVariables, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.agent_type !== undefined) {
      writer.uint32(8).int32(message.agent_type);
    }
    for (const v of message.input_variables) {
      JinjaVariable.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentInputVariables {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentInputVariables();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.agent_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.input_variables.push(JinjaVariable.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentInputVariables {
    return {
      agent_type: isSet(object.agent_type) ? darwinAgentTypeFromJSON(object.agent_type) : undefined,
      input_variables: globalThis.Array.isArray(object?.input_variables)
        ? object.input_variables.map((e: any) => JinjaVariable.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AgentInputVariables): unknown {
    const obj: any = {};
    if (message.agent_type !== undefined) {
      obj.agent_type = darwinAgentTypeToJSON(message.agent_type);
    }
    if (message.input_variables?.length) {
      obj.input_variables = message.input_variables.map((e) => JinjaVariable.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentInputVariables>, I>>(base?: I): AgentInputVariables {
    return AgentInputVariables.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentInputVariables>, I>>(object: I): AgentInputVariables {
    const message = createBaseAgentInputVariables();
    message.agent_type = object.agent_type ?? undefined;
    message.input_variables = object.input_variables?.map((e) => JinjaVariable.fromPartial(e)) || [];
    return message;
  },
};

function createBaseToolInputVariables(): ToolInputVariables {
  return { tool_type: undefined, input_variables: [] };
}

export const ToolInputVariables: MessageFns<ToolInputVariables> = {
  encode(message: ToolInputVariables, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tool_type !== undefined) {
      writer.uint32(8).int32(message.tool_type);
    }
    for (const v of message.input_variables) {
      JinjaVariable.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolInputVariables {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolInputVariables();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tool_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.input_variables.push(JinjaVariable.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToolInputVariables {
    return {
      tool_type: isSet(object.tool_type) ? darwinToolTypeFromJSON(object.tool_type) : undefined,
      input_variables: globalThis.Array.isArray(object?.input_variables)
        ? object.input_variables.map((e: any) => JinjaVariable.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ToolInputVariables): unknown {
    const obj: any = {};
    if (message.tool_type !== undefined) {
      obj.tool_type = darwinToolTypeToJSON(message.tool_type);
    }
    if (message.input_variables?.length) {
      obj.input_variables = message.input_variables.map((e) => JinjaVariable.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToolInputVariables>, I>>(base?: I): ToolInputVariables {
    return ToolInputVariables.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolInputVariables>, I>>(object: I): ToolInputVariables {
    const message = createBaseToolInputVariables();
    message.tool_type = object.tool_type ?? undefined;
    message.input_variables = object.input_variables?.map((e) => JinjaVariable.fromPartial(e)) || [];
    return message;
  },
};

function createBaseJinjaFunction(): JinjaFunction {
  return { name: undefined, description: undefined, parameters: [], return_type: undefined, example: undefined };
}

export const JinjaFunction: MessageFns<JinjaFunction> = {
  encode(message: JinjaFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    for (const v of message.parameters) {
      writer.uint32(26).string(v!);
    }
    if (message.return_type !== undefined) {
      writer.uint32(34).string(message.return_type);
    }
    if (message.example !== undefined) {
      writer.uint32(42).string(message.example);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JinjaFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJinjaFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.parameters.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.return_type = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.example = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JinjaFunction {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => globalThis.String(e))
        : [],
      return_type: isSet(object.return_type) ? globalThis.String(object.return_type) : undefined,
      example: isSet(object.example) ? globalThis.String(object.example) : undefined,
    };
  },

  toJSON(message: JinjaFunction): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters;
    }
    if (message.return_type !== undefined) {
      obj.return_type = message.return_type;
    }
    if (message.example !== undefined) {
      obj.example = message.example;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JinjaFunction>, I>>(base?: I): JinjaFunction {
    return JinjaFunction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JinjaFunction>, I>>(object: I): JinjaFunction {
    const message = createBaseJinjaFunction();
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.parameters = object.parameters?.map((e) => e) || [];
    message.return_type = object.return_type ?? undefined;
    message.example = object.example ?? undefined;
    return message;
  },
};

function createBaseJinjaObject(): JinjaObject {
  return { name: undefined, type: undefined, description: undefined, object_variables: [], object_functions: [] };
}

export const JinjaObject: MessageFns<JinjaObject> = {
  encode(message: JinjaObject, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.type !== undefined) {
      writer.uint32(18).string(message.type);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.object_variables) {
      JinjaVariable.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.object_functions) {
      JinjaFunction.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JinjaObject {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJinjaObject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.object_variables.push(JinjaVariable.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.object_functions.push(JinjaFunction.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JinjaObject {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      type: isSet(object.type) ? globalThis.String(object.type) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      object_variables: globalThis.Array.isArray(object?.object_variables)
        ? object.object_variables.map((e: any) => JinjaVariable.fromJSON(e))
        : [],
      object_functions: globalThis.Array.isArray(object?.object_functions)
        ? object.object_functions.map((e: any) => JinjaFunction.fromJSON(e))
        : [],
    };
  },

  toJSON(message: JinjaObject): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.type !== undefined) {
      obj.type = message.type;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.object_variables?.length) {
      obj.object_variables = message.object_variables.map((e) => JinjaVariable.toJSON(e));
    }
    if (message.object_functions?.length) {
      obj.object_functions = message.object_functions.map((e) => JinjaFunction.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JinjaObject>, I>>(base?: I): JinjaObject {
    return JinjaObject.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JinjaObject>, I>>(object: I): JinjaObject {
    const message = createBaseJinjaObject();
    message.name = object.name ?? undefined;
    message.type = object.type ?? undefined;
    message.description = object.description ?? undefined;
    message.object_variables = object.object_variables?.map((e) => JinjaVariable.fromPartial(e)) || [];
    message.object_functions = object.object_functions?.map((e) => JinjaFunction.fromPartial(e)) || [];
    return message;
  },
};

function createBaseJinjaEnv(): JinjaEnv {
  return {
    objects: [],
    utility_functions: [],
    agent_input_variables: [],
    env_variables: [],
    tool_input_variables: [],
    skill_input_variables: [],
  };
}

export const JinjaEnv: MessageFns<JinjaEnv> = {
  encode(message: JinjaEnv, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.objects) {
      JinjaObject.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.utility_functions) {
      JinjaFunction.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.agent_input_variables) {
      AgentInputVariables.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.env_variables) {
      JinjaVariable.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.tool_input_variables) {
      ToolInputVariables.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.skill_input_variables) {
      JinjaVariable.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JinjaEnv {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJinjaEnv();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.objects.push(JinjaObject.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.utility_functions.push(JinjaFunction.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.agent_input_variables.push(AgentInputVariables.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.env_variables.push(JinjaVariable.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tool_input_variables.push(ToolInputVariables.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.skill_input_variables.push(JinjaVariable.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JinjaEnv {
    return {
      objects: globalThis.Array.isArray(object?.objects) ? object.objects.map((e: any) => JinjaObject.fromJSON(e)) : [],
      utility_functions: globalThis.Array.isArray(object?.utility_functions)
        ? object.utility_functions.map((e: any) => JinjaFunction.fromJSON(e))
        : [],
      agent_input_variables: globalThis.Array.isArray(object?.agent_input_variables)
        ? object.agent_input_variables.map((e: any) => AgentInputVariables.fromJSON(e))
        : [],
      env_variables: globalThis.Array.isArray(object?.env_variables)
        ? object.env_variables.map((e: any) => JinjaVariable.fromJSON(e))
        : [],
      tool_input_variables: globalThis.Array.isArray(object?.tool_input_variables)
        ? object.tool_input_variables.map((e: any) => ToolInputVariables.fromJSON(e))
        : [],
      skill_input_variables: globalThis.Array.isArray(object?.skill_input_variables)
        ? object.skill_input_variables.map((e: any) => JinjaVariable.fromJSON(e))
        : [],
    };
  },

  toJSON(message: JinjaEnv): unknown {
    const obj: any = {};
    if (message.objects?.length) {
      obj.objects = message.objects.map((e) => JinjaObject.toJSON(e));
    }
    if (message.utility_functions?.length) {
      obj.utility_functions = message.utility_functions.map((e) => JinjaFunction.toJSON(e));
    }
    if (message.agent_input_variables?.length) {
      obj.agent_input_variables = message.agent_input_variables.map((e) => AgentInputVariables.toJSON(e));
    }
    if (message.env_variables?.length) {
      obj.env_variables = message.env_variables.map((e) => JinjaVariable.toJSON(e));
    }
    if (message.tool_input_variables?.length) {
      obj.tool_input_variables = message.tool_input_variables.map((e) => ToolInputVariables.toJSON(e));
    }
    if (message.skill_input_variables?.length) {
      obj.skill_input_variables = message.skill_input_variables.map((e) => JinjaVariable.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JinjaEnv>, I>>(base?: I): JinjaEnv {
    return JinjaEnv.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JinjaEnv>, I>>(object: I): JinjaEnv {
    const message = createBaseJinjaEnv();
    message.objects = object.objects?.map((e) => JinjaObject.fromPartial(e)) || [];
    message.utility_functions = object.utility_functions?.map((e) => JinjaFunction.fromPartial(e)) || [];
    message.agent_input_variables = object.agent_input_variables?.map((e) => AgentInputVariables.fromPartial(e)) || [];
    message.env_variables = object.env_variables?.map((e) => JinjaVariable.fromPartial(e)) || [];
    message.tool_input_variables = object.tool_input_variables?.map((e) => ToolInputVariables.fromPartial(e)) || [];
    message.skill_input_variables = object.skill_input_variables?.map((e) => JinjaVariable.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
